import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { sendPasswordResetEmail } from "../services/authService";

function ForgotPassword() {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setError("");
    setSuccess(false);
    setLoading(true);

    const result = await sendPasswordResetEmail(email);

    if (result.success) {
      setSuccess(true);
      setEmail("");
    } else {
      setError(result.error || t("unexpectedError"));
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center p-4">
      <div className="card max-w-md w-full">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-2">
          {t("forgotPassword")}
        </h1>

        <p className="text-center text-gray-600 mb-8">
          {t("forgotPasswordDescription")}
        </p>

        {error && (
          <div className="mb-4 rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700">
            {error}
          </div>
        )}

        {success && (
          <div className="mb-4 rounded border border-green-400 bg-green-100 px-4 py-3 text-green-700">
            {t("resetEmailSent")}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              {t("email")}
            </label>
            <input
              type="email"
              className="input-field"
              placeholder="votre@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>

          <button
            type="submit"
            className="w-full btn-primary"
            disabled={loading}
          >
            {loading ? t("sending") : t("sendResetLink")}
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link
            to="/login"
            className="font-semibold text-primary-600 hover:text-primary-700"
          >
            ← {t("backToLogin")}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
